"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Injects the theme css data into the DOM
 * @param themeName
 * @param cssData
 */
var themeInjector = function themeInjector(themeName, cssData, loadCxLast) {
  var headTag = document.getElementsByTagName("head");
  var head = headTag[0]; // check to see if style already inserted

  for (var i = 0; i < head.childNodes.length; i++) {
    var title = head.childNodes[i].title;

    if (title && title.includes("CX Component Style")) {
      return;
    }
  }

  var styleNode = document.createElement("style");
  styleNode.type = "text/css";
  styleNode.title = "CX Component Style: ".concat(themeName);
  var styleText = document.createTextNode(cssData);
  styleNode.appendChild(styleText);

  if (loadCxLast) {
    head.appendChild(styleNode);
  } else {
    head.insertBefore(styleNode, head.children[0]);
  }
};

var _default = themeInjector;
exports.default = _default;